export const SET_PLAYER_INSTANCE = 'SET_PLAYER_INSTANCE';
export const GET_PLAYER_INSTANCE = 'GET_PLAYER_INSTANCE';
